import { render, staticRenderFns } from "./KtvPermission.vue?vue&type=template&id=641902a8&scoped=true"
import script from "./KtvPermission.vue?vue&type=script&lang=js"
export * from "./KtvPermission.vue?vue&type=script&lang=js"
import style0 from "./KtvPermission.vue?vue&type=style&index=0&id=641902a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641902a8",
  null
  
)

export default component.exports